import { fileUrl } from "../../lib/api";
import { FileText, Pencil, Trash2 } from "lucide-react";

export function BollaCard({ b, onEdit, onRemove }) {
  return (
    <div data-testid={`bolla-${b.id}`} className="bg-slate-900/50 border border-slate-800 rounded-md p-4">
      <div className="flex items-center justify-between mb-2">
        <div>
          <span className="font-semibold text-slate-100">Bolla #{b.numero}</span>
          <span className="text-slate-400 text-sm ml-2">{b.fornitore?.nome || b.fornitore_nome || b.posteggio?.nome || "—"}</span>
          {b.data && <span className="text-slate-500 text-xs ml-2">{(b.data || "").slice(0, 10)}</span>}
          {b.pdf_file_id && (
            <a href={fileUrl(b.pdf_file_id)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-primary text-xs ml-2 hover:underline">
              <FileText className="w-3.5 h-3.5" /> PDF
            </a>
          )}
        </div>
        <div className="flex items-center gap-3">
          <span className="font-display font-black text-xl text-emerald-400 font-mono-plex">€ {(b.totale_ivato ?? b.totale).toFixed(2)}</span>
          <button data-testid={`edit-bolla-${b.id}`} onClick={onEdit} className="text-slate-500 hover:text-primary">
            <Pencil className="w-4 h-4" />
          </button>
          <button data-testid={`delete-bolla-${b.id}`} onClick={onRemove} className="text-slate-500 hover:text-red-400">
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
      <div className="text-sm text-slate-400 divide-y divide-slate-800">
        {b.righe.map((r, i) => (
          <div key={`${b.id}-riga-${i}`} className="flex justify-between py-1">
            <span>{r.prodotto} · <span className="font-mono-plex">{r.quantita} {r.unita}</span> × € {r.prezzo_unitario}{r.iva ? ` · IVA ${r.iva}%` : ""}</span>
            <span className="font-mono-plex text-slate-300">€ {r.totale.toFixed(2)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
